// removed by extract-text-webpack-plugin
module.exports = {"Commondenominations-wrapper":"Commondenominations-wrapper__1w-XG","commondenominations-holder":"commondenominations-holder__JBO3K","commondenominations-card":"commondenominations-card__27I6n","from":"from__3VJlt","to":"to__3dlQn"};


//////////////////
// WEBPACK FOOTER
// ./pages/currency/components/Commondenominations/Commondenominations.scss
// module id = 726
// module chunks = 68